import React, { PropsWithChildren, useState } from 'react';
import {
  SumamryButtonTitle,
  SummaryDivider,
  SummaryExtraRow,
  SummaryFunctionLayout,
  SummaryImg,
  SummaryPage,
  SummaryTextLayout,
  SummaryToggleButton,
} from './Summary.style';
import { StyledGridContainer } from '@components/Grid/Grid.style';
import { StyledDisplay, StyledParagraph } from '@components/Text';
import { Trans } from 'react-i18next';
import { HeadingColor, ImgWH, Spacing, SpacingDTM } from '@pages/CommonStyle/common.style';
import { DisplayH2 } from '@components/Text/HeadingTagDisplay.style';
import { Blog01T } from '@assets/images/blog';
import { DivAllCenter, DivFlexColumn, DivWH } from '@pages/CommonStyle/commonDiv.style';
import { IconBlueArrowRight, IconMinus, IconMinusCircleFill, IconPlus, IconPlusCircleFill } from '@assets/images/icon';
import { HeadingH3 } from '@components/Text/Heading/Heading.style';
import { useSelector } from 'react-redux';
import { CommonState } from '@redux/reducers/commonReducer';

interface ModalDefaultType {
  path: any;
}

const Summary: React.FC<PropsWithChildren<ModalDefaultType>> = ({ path }) => {
  const [activeFuncIndex, setFuncActiveIndex] = useState<number | null>(0);
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const layoutType = useSelector((state: CommonState) => state.gridLayoutType);

  const handleFuncClick = (index: number) => {
    setFuncActiveIndex((prev) => (prev === index ? 1 : index));
  };

  const handleClick = (index: number) => {
    setActiveIndex((prev) => (prev === index ? 1 : index));
  };

  const items = path.summary.function.card;

  return (
    <>
      <SummaryPage>
        <StyledGridContainer>
          <DivAllCenter>
            <DisplayH2 size="small">
              <Trans i18nKey={path.summary.title} />
            </DisplayH2>
            <Spacing pixel="8" />
            <StyledParagraph size="medium">
              <Trans i18nKey={path.summary.desc} />
            </StyledParagraph>
          </DivAllCenter>

          {path.summary.function && (
            <>
              {/* Functions Part */}
              <SummaryFunctionLayout>
                <SummaryImg img={path.summary.function.card[activeFuncIndex ?? 0].image} />
                <SummaryTextLayout>
                  {path.summary.function.card.map((item, index) => (
                    <React.Fragment key={index}>
                      <SummaryToggleButton active={activeFuncIndex === index} onClick={() => handleFuncClick(index)}>
                        {activeFuncIndex === index ? (
                          <ImgWH w="20" h="20" src={IconBlueArrowRight} />
                        ) : (
                          <>
                            <DivWH w="20" h="20" />
                          </>
                        )}
                        <SumamryButtonTitle>
                          <HeadingColor size="xxxsmall" color={activeFuncIndex == index ? '#000' : '#BDBDBD'}>
                            <Trans i18nKey={item.title} />
                          </HeadingColor>
                        </SumamryButtonTitle>
                        {activeFuncIndex === index ? <ImgWH w="20" h="20" src={IconMinus} /> : <ImgWH w="20" h="20" src={IconPlus} />}
                      </SummaryToggleButton>

                      {activeFuncIndex === index && (
                        <SummaryExtraRow gap={24}>
                          <DivWH w="20" h="20" /> {/* 왼쪽 아이콘 자리 placeholder */}
                          <StyledParagraph size="medium" color="#818181" style={{ wordBreak: 'break-word', flex: '1' }}>
                            <Trans i18nKey={item.desc} />
                          </StyledParagraph>
                          <DivWH w="20" h="20" /> {/* 오른쪽 아이콘 자리 placeholder */}
                        </SummaryExtraRow>
                      )}

                      {index < items.length - 1 && (
                        <SummaryExtraRow gap={0}>
                          {layoutType !== 'mobile' ? <DivWH w="48" h="48" /> : <DivWH w="20" h="48" />}
                          <SummaryDivider />
                          {layoutType !== 'mobile' ? <DivWH w="16" h="16" /> : <DivWH w="20" h="20" />}
                        </SummaryExtraRow>
                      )}
                    </React.Fragment>
                  ))}
                </SummaryTextLayout>
              </SummaryFunctionLayout>
            </>
          )}

          {path.summary.functionDetail && (
            <>
              <SpacingDTM d="96" t="96" m="64" />

              <SummaryFunctionLayout>
                <SummaryTextLayout>
                  {items.map((item, index) => (
                    <React.Fragment key={index}>
                      {index == 0 && (
                        <>
                          <Spacing pixel="8" />
                          <StyledDisplay size="small">
                            <Trans i18nKey={`adsfsda`} />
                          </StyledDisplay>
                          <Spacing pixel="24" />
                        </>
                      )}
                      <SummaryToggleButton active={activeIndex === index} onClick={() => handleClick(index)}>
                        <SumamryButtonTitle>
                          <HeadingColor size="xxxsmall" color={activeIndex == index ? '#000' : '#BDBDBD'}>
                            <Trans i18nKey={item.title} />
                          </HeadingColor>
                        </SumamryButtonTitle>
                        <Spacing pixel="24" />
                        {activeIndex === index ? <ImgWH w="20" h="20" src={IconMinusCircleFill} /> : <ImgWH w="20" h="20" src={IconPlusCircleFill} />}
                        <Spacing pixel="16" />
                      </SummaryToggleButton>

                      {activeIndex === index && (
                        <>
                          <Spacing pixel="8" />
                          <SummaryExtraRow gap={0}>
                            <StyledParagraph size="medium" style={{ wordBreak: 'break-word', flex: '1' }}>
                              <Trans
                                i18nKey={`adsiofmsc8nut8432cr9148ru2eio1mji12zjfmo1ihbibhiohiohadsiofmsc8nut8432cr9148ru2eio1mji12zjfmo1ihbibhiohiohadsiofmsc8nut8432cr9148ru2eio1mji12zjfmo1ihbibhiohiohadsiofmsc8nut8432cr9148ru2eio1mji12zjfmo1ihbibhiohioh`}
                              />
                            </StyledParagraph>
                            <DivWH w="72" h="0" /> {/* 왼쪽 아이콘 자리 placeholder */}
                          </SummaryExtraRow>
                        </>
                      )}

                      {index < items.length - 1 && (
                        <SummaryExtraRow gap={0}>
                          <DivWH w="0" h="48" /> {/* 왼쪽 아이콘 자리 placeholder */}
                          <SummaryDivider />
                          <DivWH w="16" h="16" /> {/* 왼쪽 아이콘 자리 placeholder */}
                        </SummaryExtraRow>
                      )}
                    </React.Fragment>
                  ))}
                </SummaryTextLayout>
                <SummaryImg img={Blog01T} />
              </SummaryFunctionLayout>
            </>
          )}
        </StyledGridContainer>
      </SummaryPage>
    </>
  );
};

export default Summary;
